import { useQuery } from '@tanstack/react-query';
import { useCommerceAPI } from '~/features/commerce-api/contexts';
import { getStoreList } from '~/services/stores/store-api';

// Fetches the full store list on demand, gated by `enabled` so it only fires once the picker opens.
export const useStoreAvailabilityList = ({ enabled }: { enabled: boolean }) => {
    const api = useCommerceAPI();

    const { data: storeListResponse, isLoading } = useQuery({
        queryKey: ['storeAvailabilityList'],
        queryFn: () => getStoreList(api, false),
        enabled,
        staleTime: 1000 * 60 * 10,
    });

    return { allStores: storeListResponse?.data, isLoading };
};
